import React from "react";

import { UnpaidInfoContainer } from "./unpaid-info-style";

const UnpaidInfoText = () => {
  return (
    <UnpaidInfoContainer>
      <h2>Canales y pasos para realizar pagos de recibos pendientes:</h2>
      <ul>
        <li>
          <strong>
            Importante: El Tomador de la póliza, esto es, el titular, es el único que puede abonar
            los recibos pendientes de pago.
          </strong>
        </li>
        <li>
          Lo más rápido es hacerlo ON LINE, desde su Área Privada, a la que puede acceder desde la
          Web o la App de ASISA.
          <ul>
            <li>
              Cuando acceda a su Área Privada desde la Web, debe asegurarse que puede ver el icono
              MIS RECIBOS.
              <strong>
                Si no eres el Tomador de la póliza, no podrás verlo y, por tanto, no podrás hacer
                esta gestión.
              </strong>
            </li>
            <li>
              Al hacer clic sobre en el icono verá que aparece una alerta en la pantalla indicando
              que tiene recibos pendientes de pago y el importe al que asciende su deuda. Si tuviese
              recibos pendientes de diferentes ramos, por ejemplo, de ASISA Salud y ASISA Vida,
              deberá abonar el total de la deuda pendiente de cada ramo en la misma operación. Puede
              dejar para otro momento el pago de los recibos pendientes del segundo ramo, pero no es
              posible fraccionar el pago de los recibos pendientes de un mismo ramo.
            </li>
            <li>
              Puede elegir la forma de pago para saldar tu deuda:
              <ul>
                <li>Mediante tarjeta bancaria, en cuyo caso, accederás a una pasarela de pago.</li>
                <li>Por BIZUM.</li>
              </ul>
            </li>
          </ul>
        </li>
        <li>
          También puede contactar con el Servicio de Atención al Cliente 91 991 19 99 / 900 922 992
          y facilitar la numeración de su tarjeta de crédito para realizarle el cargo.
        </li>
        <li>
          Si lo prefiere, puede aportar el justificante de haber hecho una transferencia bancaria a
          la cuenta de ASISA, indicando en el concepto de la transferencia el número de póliza.
          ¿Cuál es el número de la cuenta de ASISA para abonar por transferencia bancaria los
          recibos pendientes? Debe enviar un mail a asisa.informacion@asisa.es y le responderán por
          escrito.
        </li>
        <li>
          O bien, puede ir a una Delegación de ASISA y pagar en efectivo o con tarjeta de crédito.
        </li>
      </ul>

      <p>
        Nuestra recomendación es que lo haga cuanto antes, ya que no podrá recibir asistencia médica
        hasta que regularices sus pagos, pues el uso de tu tarjeta sanitaria quedará temporalmente
        restringido.
      </p>
    </UnpaidInfoContainer>
  );
};

export default UnpaidInfoText;
